<!--
     <GenericQUnitTransition
       centro='centro_id'
       @update="table_data_needs_an_update_handler(altered_qunit)"
     />

     Public methods:
       - add_qunit(business_process, parent_qunit_id)
           // Lauch add QUnit dialog of business_process with optional parent
       - launch_transition(qunit_id, transition)
           // Launch dialog for transition of qunit_id
       - close()
           // Force dialog to close

     NOTES:
       - business_process is optional if qunit is specified
-->

<template>
  <div>
    <ModalDialog
      :title="modal_title"
      :showModalDialog="show_dialog"
      :fields_to_collect="fields_to_collect"
      :submit_button_text="submit_button_caption"
      :unit="current_qunit"
      validate
      @close-dialog="cancel"
      @submit="process_form"
    >
      <template v-slot:bottom>
        <v-overlay
          absolute
          :value="!!loading"
        >
          <v-progress-circular
            indeterminate
            color="white"
          ></v-progress-circular>
        </v-overlay>
      </template>
    </ModalDialog>

  </div>
</template>


<script>
 import QUnit from '@/api/QUnit'
 import QUnitCollection from '@/qunit/QUnitCollection'
 import ModalDialog from './ModalDialog'


 export default {
   name: 'GenericQUnitTransition',

   components: {
    ModalDialog : () => import('@/components/explorer/ModalDialog'),
   },

   props: {
     centro: {required: true},
   },

   data: () => ({
     modal_title: '',
     business_process: null,
     parent_qunit_id: null,
     fields_to_collect: [],
     business_process_name: '',
     submit_button_caption: '',
     show_dialog: false,
     submit_callback: function(){},
     current_transition: {},
     current_qunit: null,
     loading: false,
   }),

   computed: {
     sort_icon() {
       return this.unitsSortDesc ? 'mdi-sort-descending' : 'mdi-sort-ascending';
     },
   },

   methods: {
     cancel() {
       this.parent_qunit_id = '';
       this.close();
       this.$emit('cancel');
     },

     close() {
       this.show_dialog = false;
     },

     async add_qunit(business_process, parent_qunit_id) {
       if (!business_process)
         throw "GenericQUnitTransition.add_qunit: business_process is required";

       parent_qunit_id = parent_qunit_id || '';
       this.business_process = business_process;
       this.parent_qunit_id  = parent_qunit_id;
       this.creation_form_error_message = ''
       
       try {
         const data = await QUnit.getFieldsToCollectDuringCreation(
           this.centro,
           business_process,
           parent_qunit_id
         )
         this.submit_callback = this.submitAddUnit;
         this.fields_to_collect = data['fields'];
         this.business_process_name = data['business_process_name'];
         this.show_dialog = true;
         // TODO:Lang
         this.modal_title = this.$vuetify.lang.translator('add') +" " + this.business_process_name;
         this.submit_button_caption = this.$vuetify.lang.translator('add');

       } catch (err) {
         console.error(err);
         this.$emit('cancel');
       }
     },

     async launch_transition(unit, transition) {
       if (transition.related_business_process)
         return await this.add_qunit(transition.related_business_process,
                                     unit.uid);

       this.current_qunit = unit;

       try {
         const data = await QUnit.getFieldsToCollectDuringTransition(
           this.centro,
           unit.uid,
           transition.id,
         )
         this.fields_to_collect = data.fields
         this.current_transition = transition;
         this.show_dialog = true
         this.submit_callback = this.submitTransition;
         this.modal_title = this.current_transition.label;
         this.submit_button_caption = this.$vuetify.lang.translator('dialog.save');

       } catch (err) {
         console.error(err);
         this.$emit('cancel');
       }
     },

     async process_form(form_data) {
       this.loading = true;
       await this.submit_callback(form_data);
       this.loading = false;
     },

     async submitAddUnit(form_data) {
       form_data.append('business_process', this.business_process);
       form_data.append('parent_process', this.parent_qunit_id);
       try {
         const data = await QUnit.createUnit(this.centro, form_data);
         this.close();
         this.$emit('update', data);
         return data;

       } catch (err) {
         console.error(err);
         this.$emit('cancel');
         return null;
       }
     },

     async submitTransition(form_data) {
       form_data.append('transition_id', this.current_transition.id);
       console.log('♥ this.current_qunit', this.current_qunit);
       try {
         const data = await QUnit.executeTransition(
           this.current_qunit._protected.centro,
           this.current_qunit.uid,
           form_data,
         );
         this.close();
         this.$emit('update', data);
         return data;

       } catch (err) {
         console.error(err);
         this.$emit('cancel');
         return null;
       }
     },
   },

   // Watch current route change to reload BP
   watch: {
     filters() {
       this.pull_filters();
     },
   },
 }
</script>


<style lang="scss">
 @import '@/sass/explorer.scss';
</style>
